module.exports = __webpack_public_path__ + "static/media/karen-wittekind.7040ef38.jpg";